import { Component, Input } from '@angular/core';
import { Validators } from '@angular/forms';

import { MixinConstructor, SafariObjectId } from '@safarilaw-webapp/shared/common-objects-models';
import { FormSubmitInfo, SafariFormComponent, SafariFormSection, SafariValidators } from '@safarilaw-webapp/shared/ui-kit/safari-form';

interface ISupportSettings {
  reviewerIsSupportContact?: boolean;
  deliveryPortalContactName?: string;
  invoiceContactName?: string;
  deliveryPortalContactEmail?: string;
  invoiceContactEmail?: string;
}

@Component({
  selector: 'sl-lpms-support-contact-settings',
  templateUrl: './support-contact-settings.component.html',
  styleUrls: ['./support-contact-settings.component.scss'],
  imports: [SafariFormComponent.standaloneImports]
})
export class LpmsSupportContactSettingsComponent extends SafariFormSection {
  @Input()
  reviewerIsSupportContact: boolean;
  @Input()
  entityLabel = 'Entity';
}
export const supportContactMixin = <B extends MixinConstructor<SafariFormComponent<ISupportSettings & { id: SafariObjectId }>>>(Base: B) =>
  class SupportContactMixin extends Base {
    reviewerIsSupportContact: boolean;
    cleanSupportContactFields(supportContactSettingsEnabled: boolean, submitInfo: FormSubmitInfo<ISupportSettings>) {
      if (!supportContactSettingsEnabled) {
        return;
      }
      if (submitInfo.appModel.reviewerIsSupportContact == true) {
        submitInfo.appModel.deliveryPortalContactName = null;
        submitInfo.appModel.invoiceContactName = null;
        submitInfo.appModel.deliveryPortalContactEmail = null;
        submitInfo.appModel.invoiceContactEmail = null;
      }
    }
    createSupportContactFields(supportContactSettingsEnabled: boolean) {
      return supportContactSettingsEnabled
        ? {
            reviewerIsSupportContact: [false],
            deliveryPortalContactName: ['', Validators.required],
            deliveryPortalContactEmail: ['', [Validators.required, SafariValidators.email, Validators.minLength(3)]],
            invoiceContactName: ['', Validators.required],
            invoiceContactEmail: ['', [Validators.required, SafariValidators.email, Validators.minLength(3)]]
          }
        : {};
    }
    patchSupportContactFields(supportContactSettingsEnabled: boolean) {
      return supportContactSettingsEnabled
        ? {
            reviewerIsSupportContact: this.appModel.reviewerIsSupportContact,
            deliveryPortalContactName: this.appModel.deliveryPortalContactName,
            deliveryPortalContactEmail: this.appModel.deliveryPortalContactEmail,
            invoiceContactName: this.appModel.invoiceContactName,
            invoiceContactEmail: this.appModel.invoiceContactEmail
          }
        : {};
    }
    setupSupportContactSubscription(supportContactSettingsEnabled: boolean) {
      if (!supportContactSettingsEnabled) {
        return;
      }
      super.subscribe(this.form.get('reviewerIsSupportContact').valueChanges, value => {
        this.reviewerIsSupportContact = value;
        if (value == false) {
          this.form.get('deliveryPortalContactName').setValidators([Validators.required]);
          this.form.get('deliveryPortalContactName').enable();
          this.form.get('invoiceContactName').setValidators([Validators.required]);
          this.form.get('invoiceContactName').enable();
          this.form.get('deliveryPortalContactEmail').setValidators([Validators.required, SafariValidators.email]);
          this.form.get('deliveryPortalContactEmail').enable();
          this.form.get('invoiceContactEmail').setValidators([Validators.required, SafariValidators.email]);
          this.form.get('invoiceContactEmail').enable();
        } else {
          this.form.get('deliveryPortalContactName').setValidators([]);
          this.form.get('deliveryPortalContactName').disable();
          this.form.get('invoiceContactName').setValidators([]);
          this.form.get('invoiceContactName').disable();
          this.form.get('deliveryPortalContactEmail').setValidators([]);
          this.form.get('deliveryPortalContactEmail').disable();
          this.form.get('invoiceContactEmail').setValidators([]);
          this.form.get('invoiceContactEmail').disable();
        }
        this.form.get('deliveryPortalContactName').updateValueAndValidity();
        this.form.get('deliveryPortalContactEmail').updateValueAndValidity();
      });
    }
  };
